import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "flex justify-content-between h-2rem bg-purple-light border-round ml-2 pl-2 align-items-center"
}
const _hoisted_3 = { class: "flex justify-content-around align-items-center justify-content-center text-sm text-color-purple-dark" }
const _hoisted_4 = { class: "font-bold ml-1 white-space-nowrap" }
const _hoisted_5 = { class: "hidden md:inline-flex ml-1" }

import { onMounted, computed } from 'vue';
import { useAuthStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'Impersonate',
  setup(__props) {

const authStore = useAuthStore();

const isLoading = computed(() => authStore.loading);

onMounted(() => init());

const init = async () => {
  if (authStore.isImpersonating && !authStore.user) {
    await authStore.getAuthUserProfile();
  }
};

const onLeave = () => authStore.leaveImpersonate();

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_unref(authStore).isImpersonating)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              width: "8rem",
              height: "2rem",
              class: "ml-2"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Icon, {
                  class: "md:hidden text-base text-color-purple",
                  library: "material-icons-round",
                  name: "fingerprint"
                }),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "hidden md:inline-flex ml-1" }, "Impersonating", -1)),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(authStore).displayName), 1),
                _createElementVNode("div", _hoisted_5, "(" + _toDisplayString(_unref(authStore).typeTitle) + ")", 1)
              ]),
              _createVNode(_component_Icon, {
                name: "close",
                class: "text-color-purple text-sm p-2 cursor-pointer",
                onClick: onLeave
              })
            ]))
      ]))
    : _createCommentVNode("", true)
}
}

})